import request from "@/utils/request";

// 获取用户信息
export const userInfo = (params) => {
  return request({
    url: "/user/info",
    method: "get",
    params,
  });
};
// 配置接口
export const configs = (params) => {
  return request({
    url: "/config/list",
    method: "get",
    params,
  });
};
// 首页公告,通知
export const getNotice = (params) => {
  return request({
    url: "/notice/list",
    method: "get",
    params,
  });
};
// 首页通知优惠卷
export const memberCouponListHome = (params) => {
  return request({
    url: "/member-coupon/list/home",
    method: "get",
    params,
  });
};
// 套餐查询接口
export const setMeals = (params) => {
  return request({
    url: "/setmeal/list",
    method: "get",
    params,
  });
};
// 查询优惠卷
export const coupons = (params) => {
  return request({
    url: "/member-coupon/list/setmeal",
    method: "get",
    params,
  });
};
// 下单
export const payinOrder = (data) => {
  return request({
    url: "/payin/order",
    method: "post",
    data,
  });
};
// 查询订单接口
export const orderQrCodeOrderInfo = (data) => {
  return request({
    url: "/order/qrCode/orderInfo",
    method: "post",
    data,
  });
};
// 修改密码
export const changePassword = (data) => {
  return request({
    url: "/user/changePwd",
    method: "post",
    data,
  });
};
// 删除账号
export const deleteAccount = (data) => {
  return request({
    url: "/user/delete",
    method: "post",
    data,
  });
};
// 获取配置文件下载地址
export const protocolConfigGetLink = () => {
  return request({
    url: "/protocol/config/getLink",
  });
};
// 获得流量
export const protocolFlow = () => {
  return request({
    url: "/protocol/flow",
  });
};
// 圖片上传
export const uploadImage = (data) => {
  return request({
    url: "/feedback/uploadImage",
    method: "post",
    data,
  });
};
// 提交反馈
export const feedbackSubmit = (data) => {
  return request({
    url: "/feedback/submit",
    method: "post",
    data,
  });
};
// 提交反馈
export const appleId = (params) => {
  return request({
    url: "/appleid/connect",
    method: "get",
    params,
  });
};
